/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { EventsTableRowFragment, EventsTableSectionFragment } from "@cosmos/hygraph-schema";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";

import {
	BackgroundContainer,
	BlurredImage,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";

import { css } from "@panda/css";
import { VStack } from "@panda/jsx";
import { EventsTable } from "./EventsTable.organism";

const glowWrap = css({
	position: "absolute",
	height: "400px",
	transform: "translateX(-25%) translateY(92px)",
	w: "65%",
	zIndex: 0,
	xxlDown: {
		w: "75%",
	},
	xlDown: {
		w: "85%",
	},
});

export const EventsTableSection = (props: EventsTableSectionFragment): React.JSX.Element | null => {
	const { blurredImage, config, events } = props || {};
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(events.some((event: EventsTableRowFragment) => !!event.title || !!event.location));
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<div className={glowWrap}>
				<BlurredImage
					image={{ id: blurredImage?.id || "", url: blurredImage?.url || "", __typename: "Asset" }}
					blurPixels={100}
					opacity={0.3}
					width={400}
					height={400}
				/>
			</div>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="events-table-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <EventsTable {...props} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
